import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PatientBriefQuickActionsContent from 'components/Patients/PatientBrief/QuickActionsFloatingPopup/PatientBriefQuickActionsContent'
import useSpecificMemberAttention from 'hooks/useSpecificMemberAttention'
import usePatientTags from 'hooks/usePatientTags'
import { useSelector } from 'react-redux'
import useRolePermissions from 'hooks/useRolePermissions'

const useStyles = makeStyles(theme => ({
  needsAttentionContainer: {
    marginBottom: 20
  }
}))

const PatientCopilotNeedsAttentionWidget = () => {
  const classes = useStyles()

  const { isHiUser } = useRolePermissions()
  const { patient } = useSelector(state => state.patientsReducer)
  const { needsAttentionTagDetails } = usePatientTags({ patient })
  const { reason, note, selectedPracticeMembersIds = [] } = needsAttentionTagDetails || {}
  const { noteWithMentions, selectedPracticeMembersTooltip, isAwaitingCurrentMembersAttention } =
    useSpecificMemberAttention({
      note,
      selectedPracticeMembersIds
    })

  return (
    <PatientBriefQuickActionsContent
      reason={reason}
      note={noteWithMentions}
      patientId={patient?.id}
      needsAttentionTagApplied={!!needsAttentionTagDetails}
      actionable={isHiUser || isAwaitingCurrentMembersAttention}
      disabledOverlayTooltip={selectedPracticeMembersTooltip}
      withPatientBrief={false}
      className={classes.needsAttentionContainer}
    />
  )
}

export default PatientCopilotNeedsAttentionWidget
